import {SxProps} from '@mui/material';

import {empionGreen} from '../../../../../../layouts/theme/EmpionColors';

export const surveySectionTitleStyles: SxProps = {
  color: empionGreen[700],
  fontSize: {xs: '1.5rem', sm: '1.75rem', md: '2rem', lg: '2.25rem'},
  lineHeight: 1.35,
  fontWeight: 400,
  textTransform: 'none',
};

export const surveySectionDescriptionStyles: SxProps = {
  color: empionGreen[500],
  fontSize: {xs: '1rem', sm: '1.125rem'},
  lineHeight: 1.45,
  fontWeight: 400,
};
